{
  "shell": {
    "logo_alt": "Rhemn",
    "navUpgrade": "Esegui l'upgrade",
    "navBilling": "Fatturazione"
  },
  "upgrade": {
    "badge": "Rhemn Pro",
    "title": "La tua scheda. Il tuo <em>dhikr</em>.<br />Elevato.",
    "subtitle": "Ogni funzione di cui hai bisogno per una giornata più consapevole — dagli orari delle preghiere e la riflessione AI sui versetti al meteo e alle attività prioritarie — in un'unica scheda nuova, calma e bellissima.",
    "comparison_aria": "Confronto dei piani",
    "free": {
      "tierLabel": "Attuale",
      "tierName": "Free",
      "freeLabel": "Sempre gratis",
      "list_aria": "Funzioni del piano Free"
    },
    "pro": {
      "list_aria": "Funzioni del piano Pro",
      "tierLabel": "Passa a",
      "tierName": "Pro",
      "pricePeriod": "/ mese",
      "priceAlt": "oppure $39.99 / anno"
    },
    "freeFeatures": {
      "clockDate": "Orologio e data",
      "verseOfDay": "Versetto coranico del giorno",
      "dailyBackground": "Foto di sfondo giornaliera",
      "qiblaCompass": "Bussola Qibla",
      "basicTasks": "Attività di base"
    },
    "proFeatures": {
      "weatherForecast": "Previsioni meteo a 5 giorni",
      "verseFavorites": "Salva e sfoglia i versetti preferiti",
      "notesAi": "Note con analisi AI",
      "priorityTasks": "Gestione delle attività prioritarie",
      "verseReflection": "Riflessione sui versetti con l'AI"
    },
    "plans": {
      "monthly": {
        "label": "Mensile",
        "price": "$4.99",
        "period": "/ mese",
        "note": "Fatturato mensilmente"
      },
      "yearly": {
        "label": "Annuale",
        "price": "$39.99",
        "period": "/ anno",
        "note": "Due mesi gratis",
        "badge": "Risparmia il 33%"
      }
    },
    "pricingTitle": "Rhemn Pro",
    "pricingDesc": "Disdici quando vuoi. Il tuo accesso continua fino alla fine del periodo di fatturazione, senza addebiti parziali.",
    "billingPeriod_aria": "Periodo di fatturazione",
    "cta": "Continua al pagamento sicuro",
    "ctaLoading": "Reindirizzamento al pagamento…",
    "promoManual": "Inserisci il codice {{code}} nella pagina successiva per ottenere lo sconto.",
    "signingUpAs": "Registrazione come {{account}}",
    "trustSignals_aria": "Segnali di fiducia",
    "reassurance": {
      "secureCheckout": "Pagamento sicuro tramite Stripe",
      "cancelAnytime": "Disdici quando vuoi, senza domande",
      "accessUntilEnd": "Accesso fino alla fine del periodo"
    },
    "errors": {
      "restoreSession": "Impossibile ripristinare la tua sessione. Riprova dall'estensione.",
      "checkoutFailed": "Avvio del pagamento non riuscito. Riprova."
    }
  },
  "upgradeStatus": {
    "unlockedFeatures_aria": "Funzioni sbloccate",
    "unlockedFeatures": {
      "weatherForecast": "Previsioni meteo a 5 giorni",
      "verseFavorites": "Salva e sfoglia i versetti preferiti",
      "notesAi": "Note con analisi AI",
      "priorityTasks": "Gestione delle attività prioritarie",
      "verseReflection": "Riflessione sui versetti con l'AI"
    },
    "success": {
      "title": "Benvenuto in Pro",
      "desc": "Il tuo abbonamento è attivo. Torna all'estensione per trovare tutte le funzioni Pro che ti aspettano.",
      "viewBilling": "Vedi dettagli di fatturazione",
      "closeTab": "Chiudi questa scheda"
    },
    "cancel": {
      "title": "Pagamento annullato",
      "desc": "Nessun problema — il tuo piano non è stato modificato e non ti è stato addebitato nulla. Puoi passare a Pro quando sei pronto.",
      "backToUpgrade": "Torna all'upgrade",
      "returnToExtension": "Torna all'estensione"
    }
  },
  "billing": {
    "title": "Fatturazione",
    "subtitle": "Gestisci il tuo abbonamento e visualizza lo storico dei pagamenti.",
    "subscription_aria": "Stato dell'abbonamento",
    "subscriptionTitle": "Abbonamento",
    "loading_aria": "Caricamento delle informazioni di fatturazione",
    "planPro": "Rhemn Pro",
    "planFree": "Rhemn Free",
    "statusLabels": {
      "active": "Attivo",
      "trialing": "Prova gratuita",
      "past_due": "Scaduto",
      "unpaid": "Non pagato",
      "canceled": "Disdetto",
      "incomplete": "Incompleto",
      "none": "Nessun abbonamento"
    },
    "planValues": {
      "proYearly": "Pro · Annuale",
      "proMonthly": "Pro · Mensile"
    },
    "warnings": {
      "paymentFailedTitle": "Pagamento non riuscito",
      "paymentFailedDesc": "Il tuo ultimo pagamento non è andato a buon fine. Aggiorna il metodo di pagamento tramite Gestisci fatturazione per mantenere l'accesso Pro.",
      "trialEndingTitle": "La prova sta per terminare",
      "trialEndingToday": "La tua prova gratuita termina oggi, {{date}}. Aggiungi un metodo di pagamento per mantenere le funzioni Pro.",
      "trialEndingInDays_one": "La tua prova gratuita termina tra {{count}} giorno, il {{date}}. Aggiungi un metodo di pagamento per mantenere le funzioni Pro.",
      "trialEndingInDays_other": "La tua prova gratuita termina tra {{count}} giorni, il {{date}}. Aggiungi un metodo di pagamento per mantenere le funzioni Pro."
    },
    "cancellationScheduled": "Disdetta programmata. Mantieni l'accesso completo a Pro fino al <strong>{{date}}</strong>.",
    "sublabel": {
      "trialEndsToday": "La prova termina oggi",
      "trialDaysRemaining_one": "{{count}} giorno rimanente di prova",
      "trialDaysRemaining_other": "{{count}} giorni rimanenti di prova",
      "renews": "Si rinnova il {{date}}",
      "accessUntil": "Accesso fino al {{date}}"
    },
    "kv": {
      "status": "Stato",
      "nextRenewal": "Prossimo rinnovo",
      "trialEnds": "Fine della prova",
      "trialDaysLeft_one": "{{count}} giorno rimanente",
      "trialDaysLeft_other": "{{count}} giorni rimanenti",
      "endsToday": "termina oggi",
      "plan": "Piano"
    },
    "upgradeNudge": {
      "title": "Sblocca le funzioni Pro",
      "desc": "Meteo, orari delle preghiere, riflessione AI sui versetti e altro — $4.99/mese o $39.99/anno.",
      "cta": "Esegui l'upgrade"
    },
    "actions": {
      "manageBilling": "Gestisci fatturazione e metodo di pagamento",
      "cancelConfirmTitle": "Disdire il tuo abbonamento?",
      "cancelConfirmDesc": "Manterrai l'accesso completo a Pro fino alla fine del periodo di fatturazione corrente. Non vengono emessi rimborsi parziali.",
      "canceling": "Disdetta in corso…",
      "yesCancel": "Sì, disdici",
      "keepPro": "Mantieni Pro",
      "cancelSubscription": "Disdici abbonamento"
    },
    "noSubscription": "Nessun abbonamento trovato.",
    "paymentHistory_aria": "Storico dei pagamenti",
    "paymentHistoryTitle": "Storico dei pagamenti",
    "invoices_aria": "Fatture",
    "invoiceView": "Vedi",
    "invoiceView_aria": "Vedi fattura del {{date}}",
    "noInvoices": "Nessuna fattura ancora.",
    "dangerZone_aria": "Zona pericolosa",
    "dangerZoneTitle": "Zona pericolosa",
    "deleteAccountTitle": "Elimina account",
    "deleteAccountDesc": "Elimina definitivamente il tuo account e tutti i dati associati — attività, note, preferiti e storico di fatturazione. Questa azione non può essere annullata.",
    "deleteAccountBtn": "Elimina account",
    "deleteConfirm": {
      "warning": "Questo eliminerà immediatamente e definitivamente:",
      "list": {
        "deleteContent": "Tutte le tue attività, note e versetti preferiti",
        "cancelSubscription": "Qualsiasi abbonamento attivo (nessun rimborso per il tempo non utilizzato)",
        "removeAccount": "Il tuo account dal nostro database",
        "signOut": "La tua disconnessione da tutti i dispositivi"
      },
      "typeToConfirm": "Digita <strong>DELETE</strong> per confermare",
      "inputPlaceholder": "DELETE",
      "deleting": "Eliminazione in corso…",
      "confirmBtn": "Elimina definitivamente il mio account",
      "cancelBtn": "Annulla"
    },
    "errors": {
      "loadFailed": "Caricamento delle informazioni di fatturazione non riuscito.",
      "cancelFailed": "Disdetta dell'abbonamento non riuscita.",
      "deleteFailed": "Eliminazione dell'account non riuscita. Riprova o contatta l'assistenza.",
      "portalFailed": "Apertura del portale di fatturazione non riuscita."
    }
  },
  "privacy": {
    "tocLabel": "Informativa sulla privacy",
    "toc_aria": "Indice dei contenuti",
    "lastUpdated": "Ultimo aggiornamento<br />22 settembre 2026",
    "sections": {
      "overview": "Panoramica",
      "informationWeCollect": "Informazioni che raccogliamo",
      "connectedServices": "Servizi collegati (Google, Todoist, Apple)",
      "howWeUse": "Come usiamo le tue informazioni",
      "howWeShare": "Come condividiamo le tue informazioni",
      "dataRetention": "Conservazione dei dati",
      "yourRights": "I tuoi diritti sulla privacy",
      "california": "Residenti in California (CCPA/CPRA)",
      "cookies": "Cookie e archiviazione locale",
      "security": "Sicurezza dei dati",
      "changes": "Modifiche a questa informativa",
      "contact": "Contattaci"
    },
    "headings": {
      "informationWeCollect": "Informazioni che raccogliamo",
      "connectedServices": "Servizi collegati (Google, Todoist, Apple)",
      "howWeUse": "Come usiamo le tue informazioni",
      "howWeShare": "Come condividiamo le tue informazioni",
      "dataRetention": "Conservazione dei dati",
      "yourRights": "I tuoi diritti sulla privacy",
      "california": "Residenti in California (CCPA / CPRA)",
      "cookies": "Cookie e archiviazione locale",
      "security": "Sicurezza dei dati",
      "changes": "Modifiche a questa informativa",
      "contact": "Contattaci"
    }
  },
  "deleteAccount": {
    "intro": "Eliminando il tuo account verranno rimossi definitivamente:",
    "list": {
      "account": "Il tuo account e il tuo profilo",
      "tasks": "Tutte le attività",
      "notes": "Tutte le note",
      "verses": "Versetti salvati",
      "billing": "Lo storico dell'abbonamento"
    },
    "irreversible": "Questa azione non può essere annullata.",
    "appleNotice": "L'eliminazione dell'account non annulla un abbonamento acquistato tramite l'App Store. Ricordati di annullarlo anche in Impostazioni → ID Apple → Abbonamenti.",
    "manageSubscription": "Gestisci abbonamento",
    "continueBtn": "Continua con l'eliminazione",
    "keepBtn": "Mantieni il mio account",
    "confirmTitle": "Eliminare il tuo account?",
    "confirmDesc": "Il tuo account e tutti i suoi dati saranno eliminati definitivamente. Questa azione non può essere annullata.",
    "confirmBtn": "Elimina definitivamente il mio account",
    "deleting": "Eliminazione in corso…",
    "error": "Non siamo riusciti a eliminare il tuo account. Controlla la connessione e riprova."
  }
}
